module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_StrokeCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_StrokeCity.png
// module id = 2194
// module chunks = 4